module.exports = __webpack_public_path__ + "static/media/photo-video.498639a5.svg";